import script from "./FlowManager.vue?vue&type=script&setup=true&lang=js"
export * from "./FlowManager.vue?vue&type=script&setup=true&lang=js"

import "./FlowManager.vue?vue&type=style&index=0&id=07636d67&scoped=true&lang=css"
import "./FlowManager.vue?vue&type=style&index=1&id=07636d67&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07636d67"]])

export default __exports__